export const numberValidator = (min: number, max: number) => {
    return (value: string) => {
        if (!value || value.trim() === '') {
            return false;
        }

        const numberValue = Number(`${value}`.replaceAll(/[^0-9]/g, ''));

        if (isNaN(numberValue)) {
            return false;
        }

        return numberValue >= min && numberValue <= max;
    };
};
